/**
 * @implements iResource
 */
export default class EventResource
{
	#resource_adaptor
	#route = 'events/';

	/**
	 *
	 * @param Resource resource_adaptor
	 */
	constructor(resource_adaptor)
	{
		this.#resource_adaptor = resource_adaptor
	}

	get(page)
	{
		if(page){
			return this.#resource_adaptor.get(this.#route + '?page=' +page)
		}
		return this.#resource_adaptor.get(this.#route)
	}
	getNested(parent_id, page)
	{
		if(page){
			return this.#resource_adaptor.get(`${this.#route}${parent_id}` + '?page=' +page)
		}
		return this.#resource_adaptor.get(`${this.#route}${parent_id}`)
	}

	show(id)
	{
		return this.#resource_adaptor.get(`${this.#route}${id}`)
	}

	post(data)
	{
		return this.put(data)
	}

	put(data)
	{
		return this.#resource_adaptor.put(this.#route, data)
	}

	putNested(parent_id, data)
	{
		return this.put(data);
	}
	patch(id, data)
	{
		return this.#resource_adaptor.patch(`${this.#route}${id}`, data)
	}
	delete(id)
	{
		return this.#resource_adaptor.delete(`${this.#route}${id}`)
	}
}